<div class="card mb-2">
  <div class="card-header">
    Recommendations
  </div>
  <div class="card-body" style="overflow: scroll;">
    <table class="table">
      <thead>
        <tr>
          <th class="bg-primary-subtle col-1">Select</th>
          <th class="bg-primary-subtle col-1">Measure</th>
          <th class="bg-primary-subtle col-3">Description</th>
          <th class="bg-primary-subtle col-2">Typical Installation Cost</th>
          <th class="bg-primary-subtle col-2">Typical Yearly Saving</th>
          <th class="bg-primary-subtle col-1">Potential Rating</th>
          <th class="bg-primary-subtle col-2">Reason NOT Selected</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let recommendation of eeRecommendations; let i = index">
          <td>
            <input
              type="checkbox"
              [(ngModel)]="recommendation.selected"
              (ngModelChange)="updateRecommendationSelection(i, $event)"
            />
          </td>
          <td>{{ recommendation.improvementType }}</td>
          <td>{{ description[i] }}</td>
          <td>{{ recommendation.indicativeCost }}</td>
          <td>{{ recommendation.typicalSaving | currency: 'GBP':'symbol-narrow' }}</td>
          <td>{{ recommendation.energyPerformanceRating }}</td>
          <td>
            <input
              type="text"
              [(ngModel)]="recommendation.reasonNotSelected"
              [disabled]="recommendation.selected"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>